import $ from 'jquery'
import store_config from '@/store/mods/parametres/config'
import MedecinRemuneration from './remuneration/index.vue'
import { estMedecin } from './remuneration/remuneration-utils'
import AffectationUnites from '@/views/parametres/unites-soins/affectation-unites.vue'
import AccesPrestations from './acces-prestations.vue'
import { estSoignant } from '@/views/parametres/unites-soins/unites-soins-utils'
import api_access from '@/api/parametres/_accessibilite'
import PersonnelImport from './import-personnel.vue'
import { CIVILITES, motDePasseInitial, identiteDepuisCompte, donneesCompte } from './identite-personnel'

function personnelVide() {
    return { id: 0, user_id: 0, name: '', civilite: '', nom_famille: '', prenoms: '', fonction: '', email: '', role_principal: '', roles: [] }
}

export default {
    name: 'param-personnels',
    components: { MedecinRemuneration, AffectationUnites, AccesPrestations, PersonnelImport },
    props: [],
    data() {
        return {
            import_enabled: false,
            personnelTab: 'profil',
            remunerationOpened: false,
            editingIsDoctor: false,
            is_loading: true,
            is_empty: false,
            save_loading: false,

            fields: [
                { key: 'nom_prenom', label: 'Nom & Prénom.s' }, { key: 'titre', label: 'Fonction' },
                { key: 'roles', label: 'Rôle.s' }, { key: 'actions', label: 'Action.s' }
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            personnel: personnelVide(),
            civilites: CIVILITES,
            identifiant_propose: null,
            proposition_minuteur: null,
            save_error: '',
            compte_cree: null,
            email_is_not_valid: false,
            user_is_existe: false,
            is_edit: false,

            all_checked: false,
            one_is_checked: [],
            text_grey: [],

            default_role: '',
            modal_title: 'Nouveau personnel',

            to_be_deleted: {
				id: 0,
				personnel: ''
			},
			is_confirm: false,
			del_loading: false,

            liste_personnel_roles: [],
            selected_user: {},
            reset_code: null,
            code_loading: false,
            code_error: false,
            editingIsSoignant: false,
            unitesOpened: false,
            consultationsOpened: false,
            examensOpened: false
        }
    },
    computed: {
        liste_roles() {
            return this.$store.getters["liste_roles"];
        },
        // URL de connexion de l'établissement (Paramètres → Établissement) : domaine des adresses générées.
        domaine_connexion() {
            const info = this.$store.getters['config_info_clinique'] || {}
            return info.url_connexion || ''
        },
    },
    mounted() {
        this.refreshListePersonnel()

        this.$store.dispatch('getListeRoles')
        if (!this.domaine_connexion) this.$store.dispatch('getConfigInfoClinique', 'info_clinique')
    },
    beforeDestroy() { clearTimeout(this.proposition_minuteur) },
    methods: {
        refreshListePersonnel() {
            this.is_loading = true
            store_config.getPersonnels().then((response) => {
                this.liste_personnel_roles = response
                if (this.liste_personnel_roles.length > 0) {
                    this.is_empty = false 
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                // Liste réservée à l'administrateur : un refus ne laisse pas le chargement tourner.
                this.liste_personnel_roles = []
                this.is_empty = true
                this.is_loading = false
            })
        },

        newUser() {
            this.personnelTab = 'profil'
            this.remunerationOpened = false
            this.editingIsDoctor = false
            this.unitesOpened = false
            this.consultationsOpened = false
            this.examensOpened = false
            this.editingIsSoignant = false
            this.is_edit = false
            this.modal_title = 'Nouveau personnel'
            this.personnel = personnelVide()
            this.identifiant_propose = null
            this.save_error = ''
            this.$refs.user_form.reset()
        },

        // Aperçu calculé par le serveur (adresse libre, homonymes compris), après une courte pause de frappe.
        proposerIdentifiant() {
            clearTimeout(this.proposition_minuteur)
            if (this.is_edit) return
            const p = this.personnel
            if (!this.domaine_connexion || !String(p.nom_famille || '').trim() || !String(p.prenoms || '').trim()) {
                this.identifiant_propose = null
                return
            }
            const demande = { civilite: p.civilite, nom_famille: p.nom_famille, prenoms: p.prenoms, domaine: this.domaine_connexion }
            this.proposition_minuteur = setTimeout(() => {
                api_access.proposerIdentifiant(demande).then(reponse => {
                    const courant = this.personnel
                    if (this.is_edit || courant.nom_famille !== demande.nom_famille || courant.prenoms !== demande.prenoms || courant.civilite !== demande.civilite) return
                    this.identifiant_propose = reponse && reponse.data ? reponse.data : null
                }).catch(() => { this.identifiant_propose = null })
            }, 350)
        },

        async savePersonnel() {
            const isValid = await this.$refs.user_form.validate();

            if (!isValid) {
                return;
            }

            if (this.is_edit && this.personnel.email && !this.validEmail(this.personnel.email)) {
                this.email_is_not_valid = true
                return;
            }

            const creation = !this.is_edit
            const data = donneesCompte(this.personnel, { creation, domaine: this.domaine_connexion, rolesSecondaires: this.one_is_checked })
            this.save_loading = true
            this.save_error = ''
            try {
                const reponse = await api_access.saveUser(data)
                if (creation) {
                    this.compte_cree = { name: reponse.name, email: reponse.email,
                        mot_de_passe_initial: (this.identifiant_propose && this.identifiant_propose.mot_de_passe_initial) || motDePasseInitial(data.prenoms) }
                }
                this.refreshListePersonnel()
                this.$refs.user_form.reset()
                this.$refs.modal_user.click()
            } catch (error) {
                const message = error && error.response && error.response.data && error.response.data.message
                this.save_error = message || 'L’enregistrement n’a pas abouti. Réessayez.'
            } finally {
                this.save_loading = false
            }
        },

        clearError() {
            this.user_is_existe = false
            this.email_is_not_valid = false
            this.save_error = ''
        },

        edit(data) {
            this.personnelTab = 'profil'
            this.remunerationOpened = false
            this.editingIsDoctor = estMedecin(data.roles)
            // 3e onglet « Unités de soins » pour les soignants (médecin, infirmier, sage-femme, administrateur).
            this.unitesOpened = false
            this.consultationsOpened = false
            this.examensOpened = false
            this.editingIsSoignant = estSoignant(data)
            this.one_is_checked = []
            this.is_edit = true

            this.identifiant_propose = null
            this.save_error = ''
            // Comptes antérieurs à la fiche : titre, nom et prénoms déduits du nom affiché (« Dr KAM Merlin »).
            this.personnel = Object.assign(personnelVide(), identiteDepuisCompte(data), {
                id: data.id,
                user_id: data.id,
                name: data.name,
                fonction: data.titre || '',
                email: data.email,
                roles: data.roles
            })
            this.modal_title = "Editer profil - " + data.name

            data.roles.forEach((el) => {
                if (el.pivot.is_default == '1') {
                    this.personnel.role_principal = {
                        role_id: el.id,
                        role_description: el.description
                    }
                    this.default_role = el.description
                } else {
                    this.one_is_checked.push(el.id)
                }
            });
        },

        toutSelectionner() {
            let is_checked = $('#rl-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.liste_roles.forEach((data) => {
                    this.text_grey[i] = 'text-grey'
                    if (data.role_description != this.default_role) {
                        this.one_is_checked.push(data.role_id)
                    }
                    

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.liste_roles.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            let is_checked = $('#rl'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("rl-tous").checked = false;
        },

        setToDelete(p) {
            this.to_be_deleted = {
                id: p.id,
                personnel: p.name
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteUser', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Personnel supprimé avec succès")
                    this.refreshListePersonnel()

                    this.is_confirm = false
                    this.$refs.del_pers.click();
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
            })
        },

        getCode(data) {
            // Le code est lu à la demande, pour ce seul compte ; une réponse tardive ne s'affiche pas sous un autre nom.
            this.selected_user = data
            this.reset_code = null
            this.code_error = false
            this.code_loading = true
            $('.view-code').modal('show')
            return store_config.getResetPwdCode(data.id).then((response) => {
                if (this.selected_user !== data) return
                this.reset_code = response && response.data ? response.data.reset_code : null
                this.code_loading = false
            }).catch(() => {
                if (this.selected_user !== data) return
                this.code_error = true
                this.code_loading = false
            })
        }
    }
}
